const externalContractsPromise = import("./external-contracts")

export const loadAppContracts = async () => {
  const config = {}
  config.deployedContracts = {}
  config.externalContracts = (await externalContractsPromise).default ?? {}
  return config
}
